<template>
  <div class="c-painel-notas">
    <v-data-table
      :sort-by.sync="porcodigo"
      :sort-desc.sync="sortDesc"
      :headers="headers"
      :items="listaNotas"
      item-key="id"
      class="pt-10 c-table-lista__notas"
      :loading="loading"
      loading-text="Procurando Notas"
      :search="search"
      disable-pagination
      hide-default-footer
    >
      <template class="pb-10" width="100px" v-slot:top>
        <v-toolbar flat>
          <v-row class="justify-center align-center">
            <v-col class="flex-grow-0 mb-0 pb-0" cols="1" sm="3" md="1">
              <v-switch
                class="c-btn-modo__edicao__empenho"
                v-model="modoEdicaoNota"
                label="Modo Edição"
              >
              </v-switch>
            </v-col>

            <v-col class="flex-grow-0 mb-0 pb-0" cols="3" sm="3" md="3">
              <v-text-field
                outlined
                class="ml-3"
                readonly
                label="Valor do Empenho"
                :value="itemEmpenho.valorTotalEmpenho | dinheiro"
              >
              </v-text-field>
            </v-col>

            <v-col class="flex-grow-0 mb-0 pb-0" cols="3" sm="3" md="3">
              <v-text-field
                outlined
                class="ml-3"
                readonly
                label="Valor Emitido"
                :value="somaValorTotalNotasEmitidas | dinheiro"
              >
              </v-text-field>
            </v-col>

            <v-col class="flex-grow-0 mb-0 pb-0" cols="3" sm="3" md="3">
              <v-text-field
                outlined
                class="ml-3"
                readonly
                label="Valor a Emitir"
                :value="valorAEmitirAtual | dinheiro"
              >
              </v-text-field>
            </v-col>

            <v-col class="mr-auto align-self-start mb-0 pb-0" cols="4" sm="4" md="4">
              <v-text-field
                hint="Busque Por: Número ou Data da Nota"
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Documentos"
                single-line
              ></v-text-field>
            </v-col>
          </v-row>

          <v-dialog
            :open-delay="dialogGerarNotaTempo"
            persistent
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dialogGerarNota"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                absolute
                right
                fab
                dark
                large
                class="mr-n6 mx-2"
                color="#363494"
                elevation="9"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>note_add</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-toolbar class="mb-5" color="#363494" dark>
                <v-toolbar-title> <span class="text-h5">{{ formTitle }}</span></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn class="mx-2" icon>
                    <v-icon id="js-modal-nota__close" dark large @click="closeGerarNota">cancel</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="mb-0 pb-0" cols="12" sm="12" md="12">
                      <gerarNota
                        v-if="dialogGerarNota"
                        :itemFiltrado="itemFiltrado"
                        :primeiroEmpenho="primeiroEmpenho"
                        :somaValorTotalNotasEmitidas="somaValorTotalNotasEmitidas"
                        :isNota="isNota"
                        :itemEmpenho="itemEmpenho"
                        :listaNotas="listaNotas"
                      >
                      </gerarNota>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogoVerDadosNF"
            persistent
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar class="mb-5" color="#75756d" dark>
                <v-toolbar-title> <span class="text-h5">{{ titleDadosNota }}</span></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn class="mx-2" icon>
                    <v-icon id="js-modal-dados__nota__close" dark large @click="closeVerDadosNF">cancel</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-container>
                <v-row>
                  <v-col class="mb-0 pb-0" cols="12" sm="12" md="12">
                    <dadosNF
                      :itemFiltradoNota="itemFiltradoNota"
                      :dadosProdutosNF="dadosProdutosNF"
                      :empenhoId="itemEmpenho.id"
                      :pregaoId="itemEmpenho.idRefPregao"
                      :clouseTelaDadosNota="clouseTelaDadosNota"
                    >
                    </dadosNF>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDeleteNota" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Tem certeza de que deseja excluir os dados desta nota?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteNota">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirmEmpenho">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogArquivosNota" max-width="960px">
            <v-card>
              <v-toolbar color="#75756d" dark>
                <v-toolbar-title>
                  Documentos da Nota/Recibo {{ itemNotaArquivos.notaRecibo || itemNotaArquivos.id || "" }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeArquivosNota">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text class="pt-6">
                <gerenciadorAnexos
                  v-if="dialogArquivosNota"
                  tipo-entidade="nota"
                  modo="persistido"
                  :entidade-id="itemNotaArquivos.id"
                  :aberto-inicial="true"
                  mensagem-opcional="Os anexos sao opcionais e ficam vinculados a esta nota."
                  @arquivo-excluido="recarregarNotas"
                  @upload-completo="recarregarNotas"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template #item.id="{ item }">
        <v-text-field
          class="c-table-lista__notas__item c-table-lista__notas__id u-hide-linha__input"
          label="ID"
          readonly
          outlined
          type="text"
          :value="item.id"
        >
        </v-text-field>
      </template>

      <template #item.notaRecibo="{ item }">
        <v-text-field
          class="c-table-lista__notas__item u-hide-linha__input u-width-fixa__520"
          label="Nota/Recibo"
          readonly
          outlined
          type="text"
          :value="item.notaRecibo"
        >
        </v-text-field>
      </template>

      <template #item.dataRecibo="{ item }">
        <v-text-field
          readonly
          outlined
          class="c-table-lista__notas__item u-hide-linha__input u-largura-135"
          label="Data Documento"
          :value="formatData(item.dataRecibo)"
        ></v-text-field>
      </template>

      <template #item.valorNf="{ item }">
        <v-text-field
          class="c-table-lista__notas__item u-hide-linha__input u-width-fixa__220"
          label="Valor"
          outlined
          readonly
          :value="item.valorNf | dinheiro"
        >
        </v-text-field>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="text-center d-flex">
          <v-btn v-if="modoEdicaoNota" class="mx-2" fab dark x-small color="#b5b5b5">
            <v-icon dark @click="deleteNota(item)">delete</v-icon>
          </v-btn>

          <v-badge
            :value="true"
            :content="`${Number(item.quantidadeArquivos) || 0}`"
            color="#75756d"
            overlap
          >
            <v-btn class="mx-2" fab dark x-small color="#75756d">
              <v-icon dark @click="abrirArquivosNota(item)">mdi-paperclip</v-icon>
            </v-btn>
          </v-badge>

          <v-badge v-if="item.edicao" bordered color="error" icon="priority_high" overlap>
            <v-btn class="mx-2" fab dark x-small color="#b5b5b5">
              <v-icon color="#75756d" dark @click="verDadosNF(item)">upload_file</v-icon>
            </v-btn>
          </v-badge>
          <v-badge v-else bordered color="green" icon="done_outline" overlap>
            <v-btn class="mx-2" fab dark x-small color="#b5b5b5">
              <v-icon color="#75756d" dark @click="verDadosNF(item)">upload_file</v-icon>
            </v-btn>
          </v-badge>
        </div>
      </template>
    </v-data-table>

    <listaItensPregao
      :titulo="tituloItensEmpenhados"
      :items="itensEmpenhados"
      :loading="loadingItensEmpenhados"
      texto-vazio="Nenhum item empenhado encontrado."
      texto-carregamento="Carregando itens empenhados"
      label-quantidade-original="Empenhado"
      label-quantidade-empenhada="Emitido"
      campo-quantidade-original="quantidade_empenhada"
      campo-quantidade-empenhada="quantidade_emitida_nota"
      campo-quantidade-remanescente="quantParaNota"
    />
  </div>
</template>

<script>
import axios from "axios";
import { urlApi, showError } from "@/global";
import barramento from "@/barramento";
import gerenciadorAnexos from "../anexos/gerenciadorAnexos";
import gerarNota from "../notas/gerarNota";
import dadosNF from "../notas/dadosNF";
import listaItensPregao from "../pregao/listaItensPregao";
import { formatarDataParaExibicao as formatarDataExibicaoBr } from "@/utils/date";

export default {
  name: "listaNotas",
  props: {
    listaNotas: [],
    itemFiltrado: [],
    itemEmpenho: {},
    isNota: [Boolean, Function],
    primeiroEmpenho: [Boolean, Function],
  },
  components: { gerarNota, dadosNF, gerenciadorAnexos, listaItensPregao },

  data: function () {
    return {
      porcodigo: "id",
      sortDesc: true,
      search: "",
      dialogGerarNota: false,
      dialogGerarNotaTempo: 1500,
      dialogoVerDadosNF: false,
      dialogDeleteNota: false,
      dialogArquivosNota: false,
      loadingItensEmpenhados: false,

      headers: [
        { text: "ID", value: "id" },
        { text: "Nota/Recibo", value: "notaRecibo" },
        { text: "Data Documento", value: "dataRecibo" },
        { text: "Valor", value: "valorNf" },
        { text: "Ações", value: "actions", sortable: false },
      ],

      loading: false,
      editedIndex: -1,
      listaNotasDados: this.listaNotas,
      valTotalEmissaoNF: {},
      execNota: false,
      dadosProdutosNF: [],
      itemFiltradoNota: [],
      modoEdicaoNota: false,
      pendencias: 0,
      pendencia: {},
      produtosDaUltimaNota: [],
      itemNotaArquivos: {},
      itensEmpenhados: [],
      ultimaNota: Number,
      idEmpenhoParaDadosNf: this.itemEmpenho.idEmpenho,
      clouseTelaDadosNota: Boolean,
      totalItensPageToNotas: -1,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Gerar Nota/Recibo" : "Lista de Documentos";
    },
    titleDadosNota() {
      return this.editedIndex === -1 ? "Dados da Nota/Recibo" : "Lista de Documentos";
    },
    tituloItensEmpenhados() {
      return "Itens Empenhados";
    },
    somaValorTotalNotasEmitidas() {
      return this.listaNotas.reduce((a, b) => a + (parseFloat(b.valorNf) || 0), 0);
    },
    valorAEmitirAtual() {
      return (parseFloat(this.itemEmpenho.valorTotalEmpenho) || 0) - this.somaValorTotalNotasEmitidas;
    },
    situacaoValorAEmitirOk() {
      return Math.abs(this.valorAEmitirAtual) <= 0.009;
    },
    verificarPendencias() {
      return this.listaNotas.some((itemNota) => itemNota.edicao);
    },
  },
  watch: {
    itemEmpenho: {
      immediate: true,
      deep: true,
      handler(emp) {
        if (emp && emp.id) {
          this.carregarItensEmpenhados();
        } else {
          this.itensEmpenhados = [];
        }
      },
    },
    listaNotas: {
      deep: true,
      handler() {
        if (this.itemEmpenho && this.itemEmpenho.id) {
          this.carregarItensEmpenhados();
        }
      },
    },
    dialogGerarNota(val) {
      if (val) {
        this.execNota = false;
      }
      if (val) this.zerarDadosPrimeiraNf();
      val || this.closeGerarNota();
    },

    dialogoVerDadosNF(val) {
      val || this.closeVerDadosNF();
    },

    somaValorTotalNotasEmitidas() {
      // O valor emitido agora e derivado pela API (SUM de notas).
    },

    dialogDeleteNota(val) {
      val || this.closeDeleteNota();
    },

    dialogArquivosNota(val) {
      val || this.closeArquivosNota();
    },

    verificarPendencias(val) {
      val ? this.atualizarNotficacaoNf(true) : this.atualizarNotficacaoNf(false);
    },
  },

  methods: {
    getUltimaNota() {
      let idEmpenho = this.itemEmpenho.id;
      let idUltimaNota = this.listaNotas[this.listaNotas.length - 1];
      axios
        .get(`${urlApi}/notas/doEmpenho?idEmpenho=${idEmpenho}&ultimaNota=${idUltimaNota.id}`, idUltimaNota)
        .then((res) => {
          this.produtosDaUltimaNota = res.data[0].listaProdutosNf;
          this.atualizarStateNotas(this.produtosDaUltimaNota);
          this.zerarDadosUltimaNf(this.produtosDaUltimaNota);
        })
        .catch(showError);
    },
    carregarItensEmpenhados() {
      this.loadingItensEmpenhados = true;

      axios
        .get(`${urlApi}/state/${this.itemEmpenho.id}`, {
          params: { incluirSemSaldo: true },
        })
        .then((res) => {
          this.itensEmpenhados = res.data || [];
        })
        .catch((err) => {
          this.itensEmpenhados = [];
          showError(err);
        })
        .finally(() => {
          this.loadingItensEmpenhados = false;
        });
    },
    zerarDadosPrimeiraNf() {
      // Agora emitidasNaNota e quantParaNota sao gerenciados via DB pelo endpoint /empenho/:id/state
    },

    zerarDadosUltimaNf() {
      // Noop
    },
    atualizarStateNotas(item) {
      if (!this.execNota) {
        for (let posicao in item) {
          if (item[posicao].quantNotaState == undefined) {
            item[posicao].quantNotaState = item[posicao].quantParaNota;
            item[posicao].quantParaEmitir = item[posicao].quantParaNota;
          }
          item[posicao].state = item[posicao].quantNotaState;

          item[posicao].emitidaNaNotaAtual = 0;
          item[posicao].valorDoItemNaNota = 0;
        }
        this.execNota = true;
      }
    },

    verDadosNF(item) {
      this.dadosProdutosNF = {
        ...item,
        dataRecibo: item.dataRecibo || "",
      };
      this.dialogoVerDadosNF = true;
      this.itemFiltradoNota = [];
    },

    abrirArquivosNota(item) {
      this.itemNotaArquivos = Object.assign({}, item);
      this.dialogArquivosNota = true;
    },

    closeArquivosNota() {
      this.dialogArquivosNota = false;
      this.itemNotaArquivos = {};
      this.recarregarNotas();
    },

    recarregarNotas() {
      if (this.itemEmpenho && this.itemEmpenho.id) {
        barramento.EnviarNotas(true, this.itemEmpenho.id);
      }
    },

    closeGerarNota() {
      this.dialogGerarNota = false;
      barramento.EnviarNotas(true, this.itemEmpenho.id);
    },

    closeVerDadosNF() {
      this.dialogoVerDadosNF = false;
      this.clouseTelaDadosNota = !true;
    },

    formatData(data) {
      return formatarDataExibicaoBr(data) || "00/00/0000";
    },
    formatDataNotaListaNotas(date) {
      return formatarDataExibicaoBr(date);
    },

    atualizarValorEmitidoNf() {
      this.valTotalEmissaoNF.notificaoNf = undefined;
      axios
        .patch(`${urlApi}/atualizarDadosNf/${this.itemEmpenho.id}`, this.valTotalEmissaoNF)
        .then(() => {})
        .catch(showError);
    },

    deleteNota(item) {
      this.editedIndex = this.listaNotasDados.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDeleteNota = true;
    },

    deleteItemConfirmEmpenho() {
      axios
        .delete(`${urlApi}/nota/${this.editedItem.id}`, this.editedItem)
        .then(() => {
          this.listaNotasDados.splice(this.editedIndex, 1);
          barramento.EnviarNotas(true, this.itemEmpenho.id);
          barramento.EnviarLoadPregao(true);
          this.modoEdicaoNota = false;
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
      this.closeDeleteNota();
    },

    closeDeleteNota() {
      this.dialogDeleteNota = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    deleteUltimNota() {
      this.ultimaNota = this.listaNotas[this.listaNotas.length - 1].id;
    },

    atualizarNotficacaoNf(isTrue) {
      this.pendencia.notificaoNf = isTrue;
      axios
        .patch(`${urlApi}/atualizarDadosNf/${this.itemEmpenho.id}`, this.pendencia)
        .then(() => {
          this.itemEmpenho.notificaoNf = this.pendencia.notificaoNf;
          barramento.EnviarLoadPregao(true);
        })
        .catch(showError);
    },
  },
};
</script>

<style>
.c-painel-notas {
  width: 100%;
}
.u-hide-linha__input .v-input__slot:before,
.u-hide-linha__input .v-text-field__details {
  content: "";
  display: none;
}
.c-table-lista__notas table {
  margin-top: 80px;
}
.c-table-lista__notas tr {
  height: 90px;
}
.c-table-lista__notas td {
  padding: 20px 10px !important;
}

.c-table-lista__notas tr {
  outline: solid 4px #ffffff !important;
  background: #f5f5f5;
}
.c-table-lista__notas .v-data-table__wrapper {
  border-radius: 7px;
}
.c-table-lista__notas {
  width: 1250px;
}
.c-table-lista__notas__id {
  width: 60px;
}
.c-table-lista__notas tr {
  height: 12px;
}
</style>
